import * as React from 'react'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

export function CompetitionAnalyzerDetailsDrawerProvider({children}) {
	const { state, replaceState, resetState } = useAppContextState({})

	return <Context.Provider value={{state, replaceState, resetState}}>
		{children}
	</Context.Provider>
}

export default Context